import * as React from 'react';
import Icon from '../Icon';


var ChevronRightIcon = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    return (React.createElement(Icon, { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", className: "ChevronRightIcon " + (disabled ? 'disabled' : ''), onClick: onClick },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.96114 3.28133C4.74585 3.07964 4.74585 2.75286 4.96114 2.55116C5.17659 2.34962 5.52581 2.34962 5.7411 2.55116L11.1714 7.63494C11.3869 7.83649 11.3869 8.16341 11.1714 8.36511L5.7411 13.4487C5.52581 13.6504 5.17659 13.6504 4.96114 13.4487C4.74585 13.2472 4.74585 12.9203 4.96114 12.7186L10.0016 8.00002L4.96114 3.28133Z", fill: "#121212" })));
};
export default React.memo(ChevronRightIcon);
